/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {TombOfNefertitiGameConfig} from "./TombOfNefertitiGameConfig";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class TombOfNefertitiGameAssets {

    public static BACKGROUND: string = "mainGame";
    public static INTRO_LOGO: string = "introLogo";

    public static BONUS_GAME_BACKGROUND: string = "bonusGame";

    public static MULTIPLIER: string = "multiplierIndicator/singleMultiplier_Landscape";
    public static MULTIPLIER_DYNAMIC: string = "multiplierIndicator/singleMultiplier_Landscape_glow";

    public static REELS_FRAME: string = "reelFrame";

    public static MAIN_GAME_BETLINE_NUMBERS_BG: string = "brownBox";
    public static BONUS_GAME_BETLINE_NUMBERS_BG: string = "blueBox";

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("numbersOpenSans800", "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset("nefertitiCountUp", "fonts/bitmapfonts/nefertitiCountUp.fnt"),
                    new BitmapFontAsset("nefertitiCountUpShine", "fonts/bitmapfonts/nefertitiCountUpShine.fnt"),
                    new BitmapFontAsset("multiplierFont", "fonts/bitmapfonts/multiplierFont.fnt")
                ]
            },
            {
                name: "intro",
                autoLoad: [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("intro0", "sheets/intro/intro0.json"),
                    new TextureAsset("introLogo", "sheets/intro/introLogo.png"),
                    new TextureAsset("SplashMap", "sheets/intro/SplashMap.png")
                ],
                animations: {
                    "navArrow": "NavArrow",
                    "navDotOn": "NavDot",
                    "navDotOff": "NavDotRing"
                }
            },
            {
                name: "introJpeg",
                assets: [
                    new TextureAsset("mainGame", "sheets/introJpeg/mainGame.jpg")
                ]
            }
        ],

        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    new TextureAsset("main3", "sheets/main/main3.json"),
                    new TextureAsset("main4", "sheets/main/main4.json"),
                    new TextureAsset("main5", "sheets/main/main5.json"),
                    new TextureAsset("main6", "sheets/main/main6.json"),
                    new TextureAsset("main7", "sheets/main/main7.json")
                ],
                animations: {
                    "reelDivider": "ui/reelDividers/div",
                    "reelDividerNearWin": "ui/reelDividers/div-attention",
                    "winEnergy": "Betlinetest0/Betlinetest_",
                    "bigWinCoin0": "bigWin/Gold Coin/",
                    "bigWinCoin1": "bigWin/Blue Gem/",
                    "bigWinCoin2": "bigWin/Red Gem/",
                    "bgGoldAnimation": "bgAnimations/goldLandscape/LCA010005",
                    "bgGoldAnimationPortrait": "bgAnimations/goldPortrait/CGS01_00022",
                    "bigWinText0Wings": "bigWin/Royal wings/RWTS01_",
                    "bigWinText1Wings": "bigWin/Mejestic wings/M01_",
                    "bigWinText2Wings": "bigWin/Divine wings/D01_",
                    "multiplierNormal": "multiplierIndicator/animation/normal/MI01_",
                    "multiplierWin": "multiplierIndicator/animation/burst/MF01_",
                    "bigWinText0": "bigWin/shine/R/R01_"
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("bonusGame", "sheets/mainJpeg/bonusGame.jpg"),
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                    new TextureAsset("mainJpeg1", "sheets/mainJpeg/mainJpeg1.json"),
                    new TextureAsset("mainJpeg2", "sheets/mainJpeg/mainJpeg2.json"),
                    new TextureAsset("mainJpeg3", "sheets/mainJpeg/mainJpeg3.json"),
                    new TextureAsset("mainJpeg4", "sheets/mainJpeg/mainJpeg4.json"),
                    new TextureAsset("mainJpeg5", "sheets/mainJpeg/mainJpeg5.json"),
                    new TextureAsset("mainJpeg6", "sheets/mainJpeg/mainJpeg6.json"),
                    new TextureAsset("mainJpeg7", "sheets/mainJpeg/mainJpeg7.json"),
                    new TextureAsset("mainJpeg8", "sheets/mainJpeg/mainJpeg8.json"),
                    new TextureAsset("mainJpeg9", "sheets/mainJpeg/mainJpeg9.json"),
                    new TextureAsset("mainJpeg10", "sheets/mainJpeg/mainJpeg10.json"),
                    new TextureAsset("mainJpeg11", "sheets/mainJpeg/mainJpeg11.json"),
                    new TextureAsset("mainJpeg12", "sheets/mainJpeg/mainJpeg12.json"),
                    new TextureAsset("mainJpeg13", "sheets/mainJpeg/mainJpeg13.json"),
                    new TextureAsset("mainJpeg14", "sheets/mainJpeg/mainJpeg14.json"),
                    new TextureAsset("mainJpeg15", "sheets/mainJpeg/mainJpeg15.json"),
                    new TextureAsset("mainJpeg16", "sheets/mainJpeg/mainJpeg16.json"),
                    new TextureAsset("mainJpeg17", "sheets/mainJpeg/mainJpeg17.json"),
                    new TextureAsset("mainJpeg18", "sheets/mainJpeg/mainJpeg18.json"),
                    new TextureAsset("mainJpeg19", "sheets/mainJpeg/mainJpeg19.json")
                ],
                animations: {
                    "fireOneCycle": "fireReelArea/start/SF01_",
                    "fireLoop": "fireReelArea/loop/Comp 1_",
                    "fireOneCycleRed": "fireReelArea/Red/start/RF01_",
                    "fireStartGreyScale": "fireReelArea/fireFrame/Start/Start purple/PS01_",
                    "fireStartInnerWhite": "fireReelArea/fireFrame/Start/Start white/white_",
                    "fireLoopInnerWhite": "fireReelArea/fireFrame/Loop/White loop/loop white_",
                    "fireLoopRed": "fireReelArea/Red/loop/RF01_",
                    "fireLoopPurple": "fireReelArea/Purple/loop/PF01_",
                    "fireLoopGreyScale": "fireReelArea/fireFrame/Loop/Purpple loop/PL01_",
                    "fireExtinguish": "fireReelArea/extinguish/S01_",
                    "fireLevel1Loop": "bgAnimations/three fire small size/Fire1 loop/fire_",
                    "fireLevel2Start": "bgAnimations/three fire small size/Fire2 start/Fire_",
                    "fireLevel2Loop": "bgAnimations/three fire small size/Fire2 loop/fire_",
                    "fireLevel3Start": "bgAnimations/three fire small size/Fire3 start/fire_",
                    "fireLevel3Loop": "bgAnimations/three fire small size/fire3loop/fire_",
                    "dust": "bgAnimations/mainGame/Dust2/D01_",
                    "softYellowFire": "fireReelArea/Soft yellow/YS01_",
                    "bigWinText1": "bigWin/shine/m/m01_",
                    "bigWinText2": "bigWin/shine/D/d01_"
                }
            },
            {
                name: "symbols",
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                    new TextureAsset("symbols1", "sheets/symbols/symbols1.json")
                ],
                animations: {
                    "wildAnim": "wildAnimation/WS01_",
                    "bonusAnim": "Bonus animation/BS01_",
                    "bonusLandingAnim": "scatterLanding/B01_"
                }
            },
            {
                name: "mainHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainHighQuality0", "sheets/mainHighQuality/mainHighQuality0.json")
                ]
            },
            {
                name: "mainJpegHighQuality",
                autoLoad : [AssetQualityLevel.MEDIUM, AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("mainJpegHighQuality0", "sheets/mainJpegHighQuality/mainJpegHighQuality0.json")
                ]
            },
            {
                name: "freespin",
                assets: [
                    new TextureAsset("freespin0", "sheets/freespin/freespin0.json")
                ],
                animations: {
                    "explode": "Blast/B01_",
                    "totalwinscroll": "old scroll/old scroll 01_00059_00011_",
                    "betLineExplode": "Betline expolde/BL01_"
                }
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        let prefix: string = "";

        if (stateName !== "spin") {
            prefix = "symbols/";
        }

        if (stateName === null || stateName === "") {
            return prefix + symbolName + "/" + symbolName;
        }

        return prefix + symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName: string, stateName: string | null = null): PIXI.Texture[] {
        return GameResources.getTextures(TombOfNefertitiGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }

    public static getSymbolWinStateTexture(symbolName: string): PIXI.Texture[] {
        if (symbolName === "W") {
            return GameResources.getTextures("wildAnim");
        } else if (symbolName === "S") {
            return GameResources.getTextures("bonusAnim");
        } else {
            let prefix: string = "";

            if (TombOfNefertitiGameConfig.instance.OVERLAPPING_SYMBOLS.indexOf(symbolName) === -1) {
                prefix = "symbols/";
            }

            return GameResources.getTextures(prefix + symbolName + "/" + symbolName + "_win/" + symbolName);
        }
    }

    public static getSymbolAttentionStateTexture(): PIXI.Texture[] {
        return GameResources.getTextures("wildAttention/W01_");
    }
}
